export const uiStyles = {
  page: {
    maxWidth: '1200px',
    width: '100%',
    minWidth: 0,
    margin: '0 auto',
    padding: '24px 0',
    boxSizing: 'border-box',
  },

  sectionCard: {
    background: 'var(--surface)',
    backdropFilter: 'var(--blur)',
    border: '1px solid var(--border)',
    borderRadius: 'var(--radius-md)',
    boxShadow: 'var(--shadow)',
    color: 'var(--text-primary)',
    padding: '24px',
    marginBottom: '24px',
  },

  heroCard: {
    background: 'var(--surface-strong)',
    backdropFilter: 'var(--blur)',
    border: '1px solid var(--border)',
    borderRadius: 'var(--radius-lg)',
    boxShadow: 'var(--shadow)',
    color: 'var(--text-primary)',
    padding: '28px',
    marginBottom: '24px',
  },

  input: {
    padding: '12px 14px',
    borderRadius: 'var(--radius-sm)',
    border: '1px solid var(--input-border)',
    background: 'var(--input-bg)',
    color: 'var(--text-primary)',
    fontSize: '16px',
    width: '100%',
  },

  select: {
    padding: '10px 12px',
    borderRadius: 'var(--radius-sm)',
    border: '1px solid var(--input-border)',
    background: 'var(--input-bg)',
    color: 'var(--text-primary)',
    fontSize: '16px',
  },

  primaryButton: {
    padding: '12px 16px',
    borderRadius: 'var(--radius-sm)',
    border: 'none',
    background: 'var(--primary-gradient)',
    color: 'white',
    fontSize: '16px',
    fontWeight: 700,
    cursor: 'pointer',
  },

  actionLink: {
    display: 'inline-block',
    padding: '8px 12px',
    borderRadius: '8px',
    background: 'var(--primary-gradient)',
    color: '#ffffff',
    textDecoration: 'none',
    fontSize: '14px',
    fontWeight: 700,
  },

  errorBox: {
    background: 'var(--error-bg)',
    color: 'var(--error-text)',
    padding: '14px 16px',
    borderRadius: '12px',
    marginBottom: '24px',
    border: '1px solid var(--border)',
  },

  tableHeader: {
    textAlign: 'left',
    padding: '12px',
    borderBottom: '1px solid var(--table-border)',
    color: 'var(--text-secondary)',
  },

  tableCell: {
    padding: '12px',
    borderBottom: '1px solid var(--table-row-border)',
    color: 'var(--text-primary)',
  },
};